import { CloseCircle, SearchIcon } from '@/assets/svg';
import { IconButton } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { isEmpty } from 'lodash';
import React from 'react';

const useStyle = makeStyles({
  title: {
    fontWeight: 600,
    fontFamily: 'Lato',
  },
  toolbar: {
    '& > .MuiToolbar-gutters': {
      paddingLeft: '20px !important',
      paddingRight: '20px !important',
    },
  },
});

const CustomSearchInput = withStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },

    '& input': {
      minWidth: 335,
      minHeight: 40,
      padding: 0,
    },
    // hide native clear button of type="search" (custom clear button is used)
    '& input[type="search"]::-webkit-search-cancel-button': {
      display: 'none',
    },
  },
}))(TextField);

const CustomHeader = ({
  searchKey,
  setSearchKey,
  title,
  isSearch = true,
  searchPlaceholder = 'Search',
  renderButton,
  renderToolbar,
}) => {
  const classes = useStyle();

  return (
    <Box className={classes.toolbar}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={2.5}
        py={2.25}
        flexWrap="wrap"
        gridGap={16}
        minHeight={76}
      >
        <Typography variant="h5" className={classes.title}>
          {title}
        </Typography>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gridGap={16}
        >
          {isSearch && (
            <CustomSearchInput
              variant="outlined"
              placeholder={searchPlaceholder}
              value={searchKey}
              onChange={(e) => setSearchKey(e.target.value)}
              type="search"
              name="table-search"
              autoComplete="off"
              inputProps={{ autoComplete: 'off' }}
              InputProps={{
                endAdornment: (
                  <>
                    <InputAdornment position="end">
                      <IconButton
                        style={{
                          visibility: !isEmpty(searchKey)
                            ? 'visible'
                            : 'hidden',
                        }}
                        onClick={() => setSearchKey('')}
                      >
                        <CloseCircle
                          height={20}
                          width={20}
                          style={{
                            color: '#666666',
                          }}
                        />
                      </IconButton>
                    </InputAdornment>
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  </>
                ),
              }}
            />
          )}
          {renderButton && renderButton()}
        </Box>
      </Box>

      {renderToolbar && (
        <>
          <Divider light />
          {renderToolbar()}
        </>
      )}
    </Box>
  );
};

export default CustomHeader;
